import useCheckPermissions from './useCheckPermissions';
import { PERMISSIONS } from '../const/permissions.const';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../reducers';
import { useFlags } from "launchdarkly-react-client-sdk";

export  function useHasCustomerExportDataPermission() {
  const isSuperUser = useSelector((state: IReduxAppState) => state.merchant?.superuser);
  const { hasPermission: hasAdminPermission} = useCheckPermissions(PERMISSIONS.ADMIN);
  const { hasPermission: hasReportPermission} = useCheckPermissions(PERMISSIONS.REPORTING);
  const { enableCustomerDataExport } = useFlags();
  
  return {
    hasCustomerExportDataPersmission : (isSuperUser || hasAdminPermission || hasReportPermission) && enableCustomerDataExport
  }
}
